<template>
  <fragment>
    <div class="main_page">
      <app-navbar></app-navbar>
      <div class="page">
        <loading :active.sync="isPageLoading" is-full-page></loading>
        <div v-if="!isPageLoading">
          <div class="page-title">
            <h1>Service Regions</h1>
          </div>
          <div class="page-content">
            <form>
              <div class="form-group row">
                <label for="searchKeyword" class="col-sm-2 col-form-label">Search by Keyword</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="searchKeyword" />
                </div>
                <div class="col-sm-2">
                  <button type="button" v-if="$permissions().hasEditServiceRegionPermission" class="btn btn-primary" @click="newServiceRegion">
                    <i class="fas fa-plus-circle"></i> Add New
                  </button>
                </div>
              </div>
            </form>
            <ul class="list-group list-group-flush border-bottom">
              <li class="list-group-item d-flex px-2" v-for="serviceRegion in searchLocalDataset(getServiceRegions)" :key="serviceRegion.id">
                <div class="mr-auto">
                  <p class="m-0">{{ serviceRegion.name }}</p>
                  
                </div>
                <a v-if="$permissions().hasEditServiceRegionPermission" role="button" href="#"
                   class="d-flex justify-content-between align-items-center flex-column" title="Edit" @click.prevent="editServiceRegion(serviceRegion.id)">
                  <img class="mb-1" src="@/assets/document.svg" alt />
                  <span class="small-grey">Edit</span>
                </a>
                <a v-if="$permissions().hasDeleteServiceRegionPermission" role="button" href="#"
                   class="d-flex justify-content-between align-items-center flex-column ml-3" title="Delete" @click.prevent="deleteServiceRegion(serviceRegion.id)">
                  <img class="mb-1" src="@/assets/red_x.svg" alt />
                  <span class="small-grey">Delete</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="bv-modal-service-region" size="lg" hide-header hide-footer :no-close-on-backdrop="true">
      <serviceRegion></serviceRegion>
    </b-modal>
  </fragment>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import MessageBox from "@/utils/messagebox";
import Toast from "@/utils/toast";

export default {
  name: "configuration-service-regions",
  components: {
    'app-navbar': () => import('@/components/app-navbar.vue'),
    'serviceRegion': () => import('@/views/configuration/components/service-region.vue')
  },
  data: function() {
    return {
      isPageLoading: true,
      searchKeyword: null
    };
  },
  computed: {
    ...mapGetters(["getServiceRegions"])
  },
  methods: {
    newServiceRegion() {
      this.resetServiceRegion().then(() => {
        this.$bvModal.show("bv-modal-service-region");
      });
    },
    editServiceRegion(id) {
      this.fetchServiceRegion(id).then(() => {
        this.$bvModal.show("bv-modal-service-region");
      });
    },
    async deleteServiceRegion(id) {
      let confirm = await MessageBox.confirm(this, "Remove Service Region", "Are you sure you want to remove this service region?");

      if (confirm) {
        this.removeServiceRegion(id).then(() => {
          Toast.success(this, "Successfully removed service region!");
        });
      }
    },
    searchLocalDataset(values) {
      if (!this.searchKeyword || this.searchKeyword === "") return values;

      return values.filter(
        i =>
          i.name.includes(this.searchKeyword) 
      );
    },
    ...mapActions(["fetchServiceRegion", "fetchServiceRegions", "removeServiceRegion", "resetServiceRegion"])
  },
  mounted: function() {
    this.fetchServiceRegions().then(() => {
      this.isPageLoading = false;
    });
  }
};
</script>
